import { Component, OnInit, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ReactiveTextInputComponent } from 'src/app/components/inputs/reactive-text-input/reactive-text-input.component';
import { ValidationMessageFn } from 'src/app/components/inputs/types/validation-message-fn';
import { SettingsCardPaymentsSectionComponent } from 'src/app/components/settings-card-payments-section/settings-card-payments-section.component';
import { StarterFormDataService } from '../../starter/starter-form-data.service';
import { CommonModule, Location } from '@angular/common';
import { SharedModule } from 'src/app/shared.module';
import { lastValueFrom } from 'rxjs';
import { AdvancedService } from 'src/app/services/advanced/advanced.service';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CtaButtonsComponent } from 'src/app/components/cta-buttons/cta-buttons.component';
import { ReactiveDropdownInputComponent } from 'src/app/components/inputs/reactive-dropdown-input/reactive-dropdown-input.component';
import { ReactiveNgSelectFieldComponent } from 'src/app/components/inputs/reactive-ng-select-field/reactive-ng-select-field.component';
import { ReactiveTextField2Component } from 'src/app/components/inputs/reactive-text-field2/reactive-text-field2.component';
import { advancedPages } from '../advanced-data';

@Component({
  selector: 'app-business-tax-id',
  standalone: true,
  imports: [
    SettingsCardPaymentsSectionComponent,
    ReactiveTextInputComponent,
    CommonModule,
    SharedModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CtaButtonsComponent,
    ReactiveTextField2Component,
    ReactiveFormsModule,
    ReactiveDropdownInputComponent,
    ReactiveNgSelectFieldComponent,
    SharedModule,
  ],
  templateUrl: './business-tax-id.component.html',
  styleUrl: './business-tax-id.component.scss',
})
export class BusinessTaxIdComponent implements OnInit {
  advancedPages: string[] = advancedPages;
  businessForm: FormControl = new FormControl();
  isValid: boolean = true;
  public location = inject(Location);

  constructor(
    private starterService: StarterFormDataService,
    private advancedService: AdvancedService
  ) {}

  ngOnInit(): void {
    this.businessForm.valueChanges.subscribe(() => {
      this.checkIfFormIsValid();
    });
    this.isValid = false;
  }

  checkIfFormIsValid() {
    console.log('checkIfFormIsValid', this.businessForm.valid);
    this.isValid = this.businessForm.valid;
  }

  handleNextClick = async () => {
    try {
      await this.businessForm.markAllAsTouched();

      if (!this.businessForm.valid) {
        return false;
      }
      var storeData = {
        store: {
          shop_name: this.starterService.merchantData.shop_name,
          is_whole_day: this.starterService.shopBusinessHours?.take_order_status?.is_whole_day
        },
        business_tax_id: this.businessForm.value,
      };
      return lastValueFrom(
        this.starterService.updateStoreDetails(storeData)
      ).then(async (result: any) => {
        console.log('handleNextClick', result);
        await lastValueFrom(this.advancedService.activateNonCOD());
        let response = await fetch("/assets/images/1x1.png");
        let data = await response.blob();
        let metadata = {
            type: "image/png"
        };
        const pobfile = new File([data], "pob.png", metadata);

        return await lastValueFrom(this.advancedService.uploadProofOfBilling(pobfile)).then(
          (response) => {
            console.log('handleNextClick response pob', response);
            // Navigate to next page
            // this.loading = false;
            return true
          },
          (error) => {
            console.error('handleNextClick response pob error:', error);
            // this.loading = false;
            return false
          }
        );

        // await (this.advancedService.uploadProofOfBilling(pobfile).subscribe((data) => {
        //   console.log("handleNextClick response pob", data)
        //   return true
        // }, (error)=> {
        //   return false
        // }));
        // // if (result) {
        // //   return true;
        // // }
        // // return false;
      });

      // await this.advancedService.updateBusinessAddress({
      //   business_name: this.businessForm.value.businessName,
      //   line_1: this.businessForm.value.line1,
      //   barangay:
      //     this.businessInfoForm.controls['sameAsPickup'].value == true
      //       ? this.shippingaddress['barangay']
      //       : this.businessInfoForm.value.barangay?.name,
      //   city:
      //     this.businessInfoForm.controls['sameAsPickup'].value == true
      //       ? this.shippingaddress['city']
      //       : this.businessInfoForm.value.city?.name,
      //   province:
      //     this.businessInfoForm.controls['sameAsPickup'].value == true
      //       ? this.shippingaddress['province']
      //       : this.businessInfoForm.value.province?.name,
      //   postal_code: this.businessInfoForm.value.zipCode,
      // });
      console.log('handlenextclick', this.businessForm.value);

      // this.router.navigate(['/advanced/business-documents-th']);

      // parent.postMessage(
      //   JSON.stringify({
      //     target: '/advanced-manual-success',
      //   }),
      //   '*'
      // );
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  async goNext() {
    const storeData = {
      store: {
        shop_name: this.starterService.merchantData.shop_name,
        is_whole_day: this.starterService.shopBusinessHours?.take_order_status?.is_whole_day
      },
      business_tax_id: this.businessForm.value,
    };

    this.starterService.updateStoreDetails(storeData).subscribe(
      async (data) => {
        console.log('Store updated response:', data);
        if (data) {
          try {
            console.log('activateNonCOD...');
            await lastValueFrom(this.advancedService.activateNonCOD());
            console.log('activateNonCOD');
          } catch (ex) {
            console.error('activateNonCOD error', ex);
          }

          parent.postMessage(
            JSON.stringify({ target: '/advanced-manual-success' }),
            '*'
          );
        }
      },
      (error) => {
        console.error('updateStoreDetails error', error);
      }
    );
  }

  goBack() {
    this.location.back();
  }
}
